import {AppState, Auth0Provider, Auth0ProviderOptions, User} from "@auth0/auth0-react";
import React from "react";
import {useNavigate} from "react-router-dom";

import {useAuth0CallbackErrorTelemetry} from "hooks/useAuth0CallbackErrorTelemetry";

const Auth0ProviderWithRedirectCallback = ({
  children,
  props,
}: {
  children: React.ReactNode;
  props: Auth0ProviderOptions;
}) => {
  const DEFAULT_POST_LOGIN_PATH = "/muggleTestV0/dashboard";
  // Fresh free-tier signups land directly on the create-project wizard so they
  // start their first project immediately. Paid signups skip this flag and go
  // through billing first (set by useLandingAuthActions).
  const NEW_PROJECT_WIZARD_PATH = "/muggleTestV0/dashboard/projects/create";
  const navigate = useNavigate();
  // Runs before the guard below so a misconfigured tenant still records the error Auth0 sent back.
  useAuth0CallbackErrorTelemetry();
  if (!(props.domain && props.clientId && props.authorizationParams)) return null;
  const onRedirectCallback = (appState?: AppState, user?: User) => {
    // Avoid logging the decoded Auth0 user profile (email, sub, name, custom
    // claims) and post-login app state to the console in production builds —
    // that is PII exposure to anyone with console access. Keep it for local
    // debugging only.
    if (process.env.NODE_ENV === "development") {
      console.log("App state:", JSON.stringify(appState));
      console.log("User logged in:", JSON.stringify(user));
    }
    if (appState?.isNewSignup) {
      navigate(NEW_PROJECT_WIZARD_PATH);
      return;
    }
    navigate(appState?.returnTo || DEFAULT_POST_LOGIN_PATH);
  };
  return (
    <Auth0Provider
      {...props}
      onRedirectCallback={onRedirectCallback}
    >
      {children}
    </Auth0Provider>
  );
};

export default Auth0ProviderWithRedirectCallback;
